import { render, staticRenderFns } from "./current.vue?vue&type=template&id=bae065ca&scoped=true"
import script from "./current.vue?vue&type=script&lang=js"
export * from "./current.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae065ca",
  null
  
)

export default component.exports